import { HiDocumentText } from "react-icons/hi2";

export const DocumentIcon = ({ width, height, color, ...props }) => (
  <HiDocumentText
    size={width || height || 24}
    color={color || "currentColor"}
    {...props}
  />
);
